<span #container class="tooltip__container">
  <div #tooltip class="tooltip" [class.tooltip-wrap]="width !== 'auto'">
    <div class="tooltip__content">
      <ng-container *ngIf="content | isTemplateRef; else defaultTemplate">
        <ng-container [ngTemplateOutlet]="content" [ngTemplateOutletContext]="{ data: tooltipData }"></ng-container>
      </ng-container>
      <ng-template #defaultTemplate>
        <p [innerHTML]="content"></p>
      </ng-template>
    </div>
  </div>
</span>
